import { t } from "@/i18n-js/instance";
import { ScoreElement } from "./ScoreElement";

export interface ScorePickerComponentProps {
  onChange: (value: number) => void;
  value: number;
}

export const ScorePickerComponent = ({
  onChange,
  value,
}: ScorePickerComponentProps) => (
  <div className="form-score-picker">
    <ScoreElement
      icon="😠"
      label={t("score_picker.awful")}
      onClick={() => onChange(1)}
      selected={value === 1}
    />
    <ScoreElement
      icon="🙁"
      label={t("score_picker.bad")}
      onClick={() => onChange(2)}
      selected={value === 2}
    />
    <ScoreElement
      icon="🙂"
      label={t("score_picker.okay")}
      onClick={() => onChange(3)}
      selected={value === 3}
    />
    <ScoreElement
      icon="😃"
      label={t("score_picker.good")}
      onClick={() => onChange(4)}
      selected={value === 4}
    />
    <ScoreElement
      icon="😍"
      label={t("score_picker.great")}
      onClick={() => onChange(5)}
      selected={value === 5}
    />
  </div>
);
